var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.799,20.071c0.375-0.547,0.787-0.618,1.122-0.618c0.333,0,0.889,0.071,1.264,0.618 c4.895,6.668,15.047,24.257,15.985,25.215c1.39,1.419,3.298,0.535,4.406-1.074c1.093-1.585,1.395-2.697,1.395-3.883 c0-0.808-15.81-29.975-17.404-32.403C29.036,5.589,28.537,5,25.918,5h-1.96c-2.614,0-2.992,0.589-4.522,2.923 c-1.597,2.433-17.406,31.6-17.406,32.408c0,1.188,0.302,2.298,1.395,3.883c1.107,1.609,3.016,2.495,4.406,1.074 c0.939-0.958,11.076-18.547,15.969-25.213L23.799,20.071z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpo);
export default __webpack_public_path__ + "static/media/expo.a9c4518446847bc4069aab5003b7ebd6.svg";
export { ForwardRef as ReactComponent };